import React, { useState } from 'react'

import { CommonTabs } from '@/components/common'
import { ChipSelectorSection } from './ChipSelectorSection.jsx'
import { DateScrollSection } from './DateScrollSection.jsx'
import { LoginStatusSection } from './LoginStatusSection.jsx'
import { DonationSidebarSection } from './DonationSidebarSection.jsx'
import { ResultCardSection } from './ResultCardSection.jsx'
import { UserMenuSection } from './UserMenuSection.jsx'
import { TopbarSection } from './TopbarSection.jsx'

import {
  StyledAlert,
  StyledSection,
  StyledContainer,
  StyledHeaderBox,
  StyledMainTitle,
  StyledHeaderDescription,
} from '../styled.jsx'

export const DonationComponents = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  return (
    <StyledSection>
      <StyledContainer>
        <StyledHeaderBox>
          <StyledMainTitle variant='h4' gutterBottom>
            App Components Reference
          </StyledMainTitle>
          <StyledHeaderDescription variant='body1'>
            Visual reference guide for all available common components including
            buttons, date pickers, text fields, textareas, checkboxes, selects,
            and loaders
          </StyledHeaderDescription>
        </StyledHeaderBox>

        <StyledAlert severity='info'>
          All components are built with Material-UI foundation and enhanced
          functionality.
        </StyledAlert>

        <CommonTabs
          id='component'
          value={activeTab}
          onChange={handleTabChange}
          tabs={[
            {
              label: 'Chip Selector',
              content: <ChipSelectorSection />,
            },
            {
              label: 'Date Scroll',
              content: <DateScrollSection />,
            },
            {
              label: 'Login Status',
              content: <LoginStatusSection />,
            },
            {
              label: 'User Menu',
              content: <UserMenuSection />,
            },
            {
              label: 'Tenant Topbar',
              content: <TopbarSection />,
            },
            {
              label: 'Donation Sidebar',
              content: <DonationSidebarSection />,
            },
            {
              label: 'Result Card',
              content: <ResultCardSection />,
            },
          ]}
        />
      </StyledContainer>
    </StyledSection>
  )
}
